// @view/authentication/EmailValidationBodyLoading.view.tsx

import React from "react";
import type { EmailValidationViewProps } from "@ps-bridge/contracts/emailValidation";
import * as styles from "@styles/EmailValidation.css";

type EmailValidationBodyLoadingContractProps = Pick<EmailValidationViewProps, never>;

const EmailValidationBodyLoadingView: React.FC<EmailValidationBodyLoadingContractProps> = () => {
  return <p className={styles.subtitle}>Verifying your email address now...</p>;
};

export default EmailValidationBodyLoadingView;
